/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Form, Field } from "react-final-form";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import Select from "react-select";
import useCustomerHook from "../customers/useCustomerHook";

const AddExpenses = () => {
  const { customers } = useCustomerHook();
  // Replace with actual customer list from API or state
  const customerOptions = React.useMemo(
    () =>
      customers?.map((customer) => ({
        value: customer.id,
        label: customer?.user?.full_name,
        data: customer,
      })) || [],
    [customers]
  );

  const onSubmit = async (values) => {
    const formData = new FormData();
    for (const field in values) {
      formData.append(field, values[field]);
    }
    console.log("Submitted:", values);
    try {
      // Make sure file is properly handled
      if (values.date instanceof Date) {
        formData.set("date", values.date.toISOString().split("T")[0]);
      }
      if (values.file) {
        formData.append("file", values.file);
      }

      // Handle customer selection (if it's an object with value property)
      if (
        values.customer_details &&
        typeof values.customer_details === "object"
      ) {
        formData.append("customer", values.customer_details.value);
      }
      if (values?.category_name && typeof values.category_name === "object") {
        formData.append("category", values.category_name.value);
      }

      const response = await fetch("/expenses/view-create/", {
        method: "POST",
        body: formData,
        credentials: "include",
        headers: {
          "X-CSRFToken": document.cookie
            .split("; ")
            .find((row) => row.startsWith("csrftoken="))
            ?.split("=")[1],
        },
        // No Content-Type header needed as FormData sets it automatically
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Success:", data);
      window.location.href = "/expenses";
      // Handle success (e.g., redirect or show success message)
    } catch (error) {
      console.error("Error submitting expense:", error);
      // Handle error (e.g., show error message to user)
    }
    // API call can go here
  };

  // Expense type options (replace with your actual categories if needed)
  const [expenseTypeOptions, setExpenseTypeOptions] = useState([]);

  useEffect(() => {
    // Fetch expense types from API
    fetch("/expenses/categories/")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setExpenseTypeOptions(
            data.map((cat) => ({
              value: cat.id,
              label: cat.name,
            }))
          );
        }
      })
      .catch((err) => {
        console.error("Error fetching expense types:", err);
      });
  }, []);

  return (
    <>
      <div className={`main-wrapper`}>
        <Header menu />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Add Expenses</h3>
                </div>
              </div>
            </div>
            <div className="card customers">
              <div className="card-body">
                <Form
                  onSubmit={onSubmit}
                  initialValues={{ date: new Date() }}
                  render={({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <label>
                            Expense Name: <span className="text-danger">*</span>
                          </label>
                          <Field
                            name="name"
                            component="input"
                            type="text"
                            className="form-control"
                            placeholder="Enter expense name"
                            required
                          />
                        </div>
                        <div className="col-md-12 mb-3">
                          <label>
                            Date: <span className="text-danger">*</span>
                          </label>
                          <Field name="date">
                            {({ input }) => (
                              <DatePicker
                                className="datetimepicker form-control"
                                selected={input.value}
                                onChange={input.onChange}
                                dateFormat="dd/MM/yyyy"
                                disabledPast
                                placeholderText="Select date"
                                required
                              />
                            )}
                          </Field>
                        </div>
                        <div className="col-md-12 mb-3">
                          <label>
                            Expense Type: <span className="text-danger">*</span>
                          </label>
                          <Field name="category_name">
                            {({ input }) => (
                              <Select
                                {...input}
                                onChange={input.onChange}
                                options={expenseTypeOptions}
                                placeholder="Select Expense Type"
                                required
                              />
                            )}
                          </Field>
                        </div>

                        <div className="col-md-12 mb-3">
                          <label>
                            Amount: <span className="text-danger">*</span>
                          </label>
                          <Field
                            name="amount"
                            component="input"
                            type="number"
                            className="form-control"
                            placeholder="Enter amount"
                            required
                          />
                        </div>

                        <div className="col-md-12 mb-3">
                          <label>Invoice Number:</label>
                          <Field
                            name="invoice_number"
                            component="input"
                            type="text"
                            className="form-control"
                            placeholder="Enter invoice number"
                          />
                        </div>

                        <div className="col-md-12 mb-3">
                          <label>Notes:</label>
                          <Field
                            name="notes"
                            component="textarea"
                            rows={2}
                            className="form-control"
                            placeholder="Enter notes"
                          />
                        </div>

                        <div className="col-md-12 mb-3">
                          <label>File:</label>
                          <Field name="file">
                            {({ input }) => (
                              <input
                                type="file"
                                className="form-control"
                                onChange={(e) =>
                                  input.onChange(e.target.files[0])
                                }
                              />
                            )}
                          </Field>
                          <small className="text-muted">
                            Upload receipt or supporting documentation
                          </small>
                        </div>

                        <div className="col-md-12 mb-3">
                          <label>Customer:</label>
                          <Field name="customer_details">
                            {({ input }) => (
                              <Select
                                {...input}
                                onChange={input.onChange}
                                options={customerOptions}
                                placeholder="Select Customer"
                              />
                            )}
                          </Field>
                        </div>
                        <div className="col-md-12 mb-3">
                          <label>Supplier </label>
                          <Field
                            name="supplier"
                            component="input"
                            type="text"
                            className="form-control"
                            placeholder="Enter supplier name"
                          />
                        </div>

                        <div className="col-md-12 text-end mt-4">
                          <button type="submit" className="btn btn-primary">
                            Add Expenses
                          </button>
                        </div>
                      </div>
                    </form>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddExpenses;
